/**
 * 🟥 CUADRO NEGRO — DeviceSwitchButton (2026-07-06)
 *
 * Botón global cíclico Desktop → Tablet → Cell → Desktop.
 * Consume el estado global `deviceMode` del GlobalUIContext.
 * NO usa localStorage. SIEMPRE visible.
 */
import { Monitor, Tablet, Smartphone } from 'lucide-react';
import { useGlobalUI } from '../context/GlobalUIContext';
import { useLanguage } from '../context/LanguageContext';

const ICONS = { desktop: Monitor, tablet: Tablet, cell: Smartphone };
const LABELS = {
  es: { desktop: 'Ordenador (1280px)', tablet: 'Tablet (768px)', cell: 'Celular (375px)' },
  en: { desktop: 'Desktop (1280px)',   tablet: 'Tablet (768px)', cell: 'Cell (375px)' },
};

const DeviceSwitchButton = () => {
  const { deviceMode, handleDeviceSwitch } = useGlobalUI();
  const { language } = useLanguage();
  const Icon = ICONS[deviceMode] || Monitor;
  const label = (LABELS[language === 'es' ? 'es' : 'en'] || LABELS.en)[deviceMode];

  return (
    <button
      type="button"
      onClick={handleDeviceSwitch}
      title={label}
      aria-label={label}
      data-testid="device-view-btn"
      data-view={deviceMode}
      className="p-1.5 text-slate-400 hover:text-white hover:bg-slate-700/50 rounded-lg transition-colors"
    >
      <Icon className="w-4 h-4" strokeWidth={1.7} />
    </button>
  );
};

export default DeviceSwitchButton;
